import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import categorySaga from 'pages/Category/saga';
import categoryReducer, { initialState as categoryInitialState } from 'pages/Category/reducer';
import { listSmtp, toggleDrawer, toggleDeleteModal } from './action';
import { SmtpTableConfig } from './SmtpTableConfig';
import AddAddonSMTPDrawer from 'components/AddAddonSMTPDrawer';
import clientReducer, { initialState as clientInitialState } from 'pages/Client/reducer';
import clientSaga from 'pages/Client/saga';
import orderReducer, { initialState as orderInitialState } from 'pages/Orders/reducer';
import orderSaga from 'pages/Orders/saga';
function AddSMTP() {
  useInjectReducer({ key: 'smtp', reducer });
  useInjectSaga({ key: 'smtp', saga });
  useInjectReducer({ key: 'category', reducer: categoryReducer });
  useInjectSaga({ key: 'category', saga: categorySaga });
  useInjectReducer({ key: 'client', reducer: clientReducer });
  useInjectSaga({ key: 'client', saga: clientSaga });
  useInjectReducer({ key: 'order', reducer: orderReducer });
  useInjectSaga({ key: 'order', saga: orderSaga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [deleteModalToggle, setDeleteModalToggle] = useState(false);
  const [selectedSmtp, setselectedSmtp] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const smtpState = useSelector((state) => state.smtp || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = SmtpTableConfig(
      handleSearch,
      handleReset,
      editUserSmtp,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listSmtp({ page: 1, limit: 10 }));
  }, []);

  const resetPagination = () => setCurrentPage(1);

  const editUserSmtp = (smtp) => {
    setselectedSmtp(smtp);
    dispatch(toggleDrawer());
  };

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listSmtp(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listSmtp({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };
  // const handleDeleteModalToggle = () => dispatch(toggleDeleteModal());

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listSmtp({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card
        title="Manage SMTP Addon"
        extra={
          <AddAddonSMTPDrawer
            initialState={initialState}
            categoryInitialState={categoryInitialState}
            clientInitialState={clientInitialState}
            selectedSmtp={selectedSmtp}
            orderInitialState={orderInitialState}
            resetPagination={resetPagination}
            editUserSmtp={editUserSmtp}
            roleAddResponsibility={_.includes(
              authState.userResponsibilities,
              'ADD_SMTP_ADDON',
            )}
          />
        }
      >
        <Table
          columns={columns}
          loading={smtpState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={smtpState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={smtpState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={smtpState.loading}
          onChange={onPageChange}
        />
      </Card>
      {/* <ConfirmModal
        title={'Delete Portfolio Confirmation'}
        text={'Are you sure you want to delete this portfolio ?'}
        toggle={smtpState.deleteModal}
        loading={smtpState.loading}
        handleDeleteModalToggle={handleDeleteModalToggle}
        onDelete={onDelete}
      /> */}
    </>
  );
}

export default AddSMTP;
